import React from 'react';
import {Typography} from '@mui/material';

/**
 * Displays metadata about the summary (item count, processing time).
 */
const SummaryMetadata = ({metadata}) => {
    if (!metadata) return null;

    const itemCount = metadata.segmentCount || metadata.itemCount || 0;
    const processingTime = metadata.processingTimeMs
        ? ` • ${(metadata.processingTimeMs / 1000).toFixed(1)}s`
        : '';

    return (
        <Typography variant="caption" color="text.secondary" sx={{fontSize: '0.7rem'}}>
            {itemCount} items{processingTime}
        </Typography>
    );
};

export default SummaryMetadata;
